import Script from 'next/script'

type JsonLdScriptProps = {
    id: string
    data: Record<string, unknown>
}

export const JsonLdScript = ({ id, data }: JsonLdScriptProps): JSX.Element => (
    <Script
        id={id}
        // eslint-disable-next-line i18next/no-literal-string
        type="application/ld+json"
        // eslint-disable-next-line i18next/no-literal-string
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
            __html: JSON.stringify(data, null, '\t')
        }}
    />
)
